module.exports = __webpack_public_path__ + "bbe80240fc30aa83d10d367cbacb5fb4.pdf";